import { CheckboxInput } from "@/external/ensolvers-core-frontend-mui-v5/components/FormInputs/CheckBoxInput";
import { Control, FieldValues, Path } from "react-hook-form";
import OnboardingCheckboxLogo from "../../../assets/images/onboarding-checkbox-logo.svg";

interface Props<TFieldValues extends FieldValues = FieldValues> {
  label: string | React.JSX.Element;
  propertyName: Path<TFieldValues>;
  control: Control<TFieldValues>;
  id?: string;
}

export const OnboardingCheckbox = <TFieldValues extends FieldValues = FieldValues>({
  label,
  propertyName,
  control,
  id,
}: Props<TFieldValues>) => {
  return (
    <CheckboxInput
      label={label}
      propertyName={propertyName}
      control={control}
      FormControlLabelProps={{ sx: { marginLeft: 0 } }}
      CheckboxProps={{
        id: id,
        sx: { padding: "0 1rem 0 0" },
        icon: <img src={OnboardingCheckboxLogo.src} />,
      }}
    />
  );
};
